import { AuthType } from "../models/enums";
import { logger } from "../Services/LoggingService";

interface FetchOptions {
    method?: string,
    headers?: HeadersInit | undefined,
    body?: string,
  };

  export interface ApiResponse {
    status: number,
    headers?: any
    response?: string,
  };
  
export const apiClient = async (endpoint: string, options?: FetchOptions, auth: AuthType = AuthType.None) => {
    if (options === null || options === undefined) {
        options = {}
    }
    if (options.method === "") {
        options.method = "GET";
    }

    if (options.headers === undefined || options.headers === null) {
        // No Auth
        if (auth === AuthType.None) {
            options.headers = {
                "Content-Type": "application/json",
            };
        }  

        // Auth via a (Bearer) Token
        if (auth === AuthType.Token) {
            options.headers = {
                Authorization: `Bearer ${getAccessToken(null)}`,
                "Content-Type": "application/json",
            };
        }

        // Basic (user/pass) Auth
        if (auth === AuthType.Basic) {
            let base64 = require('base-64');
            const username = "RpgCore";
            const password = "!E@tYell0wSn0w";

            options.headers = {
                Authorization: "Basic " + base64.encode(username + ":" + password),
                "Content-Type": "application/json",
            };
        }
    }
  
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/${endpoint}`, options)
        .then(async (fetchRet) => {
            const data: ApiResponse = {
                status: fetchRet.status,
                headers: GetResponseHeaderEntries(fetchRet.headers.entries()),
                response: ""
            };

            if (data.headers["header_content-type"] === "application/json; charset=utf-8") {
                data.response = await fetchRet.json();
            } else {
                data.response = await fetchRet.text();
            }

            if ((data.status !== 200) && (data.status !== 201) && (data.status !== 202) && (data.status !== 204)) {
                //logger.error("Got a bad apiClient response status of: " + data.status + ". ", fetchRet);
                if (data.response?.includes("Error, TS001: This account") && data.response?.includes("needs re-authentication")) {
                    data.response = "The account needs re-authentication.";
                }
                throw new Error(data.response);
            }

            return data;
        })
        .catch((err) => {
            logger.warning("Error with 'Fetching'.", err);
            const data: ApiResponse = {
                status: 500,
                response: err
            };

            return data;
        });
};

// get a token
export function getAccessToken(data: any) {
    const loginInfo = `${data}&grant_type=password`;

    return fetch(`${process.env.REACT_APP_API_BASE_URL}/Token`, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
      body: loginInfo,
    }).then((response) => response.json());
}

function GetResponseHeaderEntries(headerEntries: any) {
    const entries: any = {};

    for (var pair of headerEntries) {
        entries["header_" + pair[0]] = pair[1];

        // // Headers: x-rate-limit-limit: 100
        // // Headers: x-rate-limit-remaining: 75
        // // Headers: x-rate-limit-reset: 27389
        // if (pair[0].toLowerCase().includes("rate") || pair[0].toLowerCase().includes("retry")) {
        //     //logger.info("Headers: " + pair[0] + ': ' + pair[1], pair);
        //     if (pair[0] === "x-rate-limit-reset") {
        //         const addingSeconds = parseInt(pair[1], 10);
        //         const tempDate = new Date(GetUtcDateTime());
        //
        //         tempDate.setSeconds(tempDate.getSeconds() + addingSeconds);
        //
        //         setApiRetryTime(tempDate.toLocaleString());
        //     }
        // }
    }

    return entries;
}
    
function GetUtcDateTime() {
    let tempDate = new Date();

    // Returns mm/dd/yyyy hh:mm:ss AM/PM
    tempDate = new Date((tempDate.getUTCMonth() + 1) + "/" + tempDate.getUTCDate() + "/" + tempDate.getUTCFullYear() + " " + tempDate.getUTCHours() + ":" + tempDate.getUTCMinutes() + ":" + tempDate.getUTCSeconds());
    tempDate.setHours(tempDate.getHours() - (tempDate.getTimezoneOffset() / 60));

    return tempDate.toUTCString();
}
